import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-7">
              <h4>Join Our Newsletter</h4>
              <p>Stay up-to-date with the latest news, product launches, and exclusive offers. Subscribe to our newsletter today!</p>
              <form action="#" method="post" className="php-email-form">
                <div className="newsletter-form">
                  <input type="email" name="email" placeholder="Enter your email address" required />
                  <input type="submit" value="Subscribe" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Top Section */}
      <div className="container footer-top">
        <div className="row gy-4">
          {/* About Us Section */}
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index" className="d-flex align-items-center">
              <span className="sitename">TechBiz <span className="sitename-1">SoftwareSolutions</span></span>
            </a>
            <div className="footer-contact pt-3">
              <p>Airoli, Navi Mumbai, Maharashtra- 400708, India</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 81040 43108 / +91 81694 30874</span></p>
              <strong>Email:</strong> 
                <ul className=''>
                  <li>contact@techbizsoftwaresolutions.com</li>
                  <li>sales@techbizsoftwaresolutions.com</li>
                </ul>
              
            </div>
          </div>

          {/* Useful Links Section */}
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#hero">Home</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#about">About Us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Services</a></li>
              {/* <li><i className="bi bi-chevron-right"></i> <a href="#team">Team</a></li> */}
              <li><i className="bi bi-chevron-right"></i> <a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Our Services Section */}
          <div className="col-lg-3 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Custom Software Development</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Mobile App Development</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">UI/UX Design</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="#services">Cloud Solutions</a></li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="col-lg-3 col-md-12">
            <h4>Follow Us</h4>
            <p>Follow us on social media to stay updated with our latest projects, client success stories, and software solutions!</p>
            <div className="social-links d-flex">
              <a href="#" target="_blank" rel="noopener noreferrer"><i className="bi bi-twitter"></i></a>
              <a href="https://www.facebook.com/profile.php?id=61574458053758" target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/techbizsoftwaresolutions/" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
              <a href="#" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="container copyright text-center">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">TechBiz <span style={{ fontSize: '10px' }}>SoftwareSolutions</span></strong> || <span>All Rights Reserved</span> &emsp; <span> <a href="terms-and-conditions">Terms & Conditions</a> |  <a href="privacy-policy">Privacy Policy</a></span></p>
      </div>

    </footer>
  );
};

export default Footer;
